module.exports = __webpack_public_path__ + "static/media/biocore-introductory.ff695bbd.png";